import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import { Centrifuge } from 'centrifuge';
import Vue from 'vue';
var Event = /*#__PURE__*/function () {
  function Event(name, _ref) {
    var model = _ref.model,
      action = _ref.action;
    _classCallCheck(this, Event);
    this.name = name;
    this.model = model;
    this.action = action;
  }
  return _createClass(Event, [{
    key: "emit",
    value: function emit(context, data) {
      if (data && this.model) {
        context.$bus.emit.created(this.model, data);
      }
    }
  }]);
}();
var eventTypes = {
  'message-received': new Event('message-received', {
    model: 'CustomerMessage',
    action: function action(context, data) {
      var i18n = context.i18n;
      if (context.$config.instance === 'dev') {
        if (data && data.sender === 2) {
          Vue.notification.toast({
            title: i18n.t('plugins.centrifuge.messageFrom', {
              label: data.senderLabel
            }),
            text: data.title || data.body,
            action: {
              label: i18n.t('general.view'),
              click: function click() {
                if (!context.route.path.includes("message/".concat(data.idCustomer))) {
                  context.$panel.create("/message/chat/".concat(data.idCustomer));
                }
              }
            }
          });
        }
      }
    }
  }),
  'message.updated': new Event('message.updated', {
    model: 'CustomerMessage',
    action: function action(context, data) {
      context.$bus.emit.updated('CustomerMessage', data);
    }
  }),
  'account.updated': new Event('account.updated', {
    model: 'Location',
    action: function action(context, data) {
      context.$auth.syncInfo();
    }
  }),
  'reservation.created': new Event('reservation.created', {
    model: 'Reservation',
    action: function action(context, data) {
      var _data$source;
      var i18n = context.i18n;
      if (data.idReservation) {
        context.$bus.emit.created('Reservation', data);
      } else if (data.idReservation) {
        context.$bus.emit.created('ReservationCustomer', data);
      }
      if ((data === null || data === void 0 ? void 0 : data.event) === 'reservation.created' && ((_data$source = data.source) === null || _data$source === void 0 ? void 0 : _data$source.type) === 'customer') {
        var _data$source2, _data$source2$user;
        Vue.notification.toast({
          title: i18n.t('plugins.centrifuge.booked', {
            name: (_data$source2 = data.source) === null || _data$source2 === void 0 ? void 0 : (_data$source2$user = _data$source2.user) === null || _data$source2$user === void 0 ? void 0 : _data$source2$user.name
          }),
          action: {
            label: i18n.t('general.view'),
            click: function click() {
              if (data.idReservation) {
                context.$panel.create("/appointment/attendee/".concat(data.idCustomer));
              } else if (data.idReservation) {
                context.$panel.create("/appointment/".concat(data.idCustomer, "?date=").concat(data.date));
              }
            }
          }
        });
      }
    }
  })
};
export default (function (context, inject) {
  var plugin = {
    instance: null,
    channel: null,
    connect: function connect() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _$auth$info, $auth, events;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              $auth = context.$auth;
              events = $auth === null || $auth === void 0 ? void 0 : (_$auth$info = $auth.info) === null || _$auth$info === void 0 ? void 0 : _$auth$info.events;
              if (!(events && events.enabled)) {
                _context2.next = 15;
                break;
              }
              _this.disconnect();
              _this.instance = new Centrifuge(events.endpoints.websocket, {
                token: events.token,
                getToken: function () {
                  var _getToken = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    var _info$events;
                    var info;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return context.$auth.fetchInfo();
                        case 2:
                          info = _context.sent;
                          return _context.abrupt("return", info === null || info === void 0 ? void 0 : (_info$events = info.events) === null || _info$events === void 0 ? void 0 : _info$events.token);
                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  function getToken() {
                    return _getToken.apply(this, arguments);
                  }
                  return getToken;
                }()
              });
              _this.instance.on('connected', function (ctx) {
                // now client connected to Centrifugo and authenticated.
                console.log(ctx);
              });
              _this.instance.on('disconnected', function (ctx) {
                // now client disconnected from Centrifugo
                console.log(ctx);
              });
              _this.instance.on('subscribing', function (ctx) {
                // now client connected to Centrifugo and authenticated.
                // console.log('subscribing')
              });
              _this.instance.on('subscribed', function (ctx) {
                // now client connected to Centrifugo and authenticated.
                // console.log(ctx)
              });
              _this.instance.on('unsubscribed', function (ctx) {
                // now client disconnected from Centrifugo
                // console.log(ctx)
              });
              _this.instance.on('publication', function (ctx) {
                try {
                  var _ctx$data;
                  var eventType = eventTypes[ctx === null || ctx === void 0 ? void 0 : (_ctx$data = ctx.data) === null || _ctx$data === void 0 ? void 0 : _ctx$data.event];
                  if (!eventType) {
                    var eventTypeKey = Object.keys(eventTypes).find(function (key) {
                      var _ctx$data2, _ctx$data2$event;
                      return ctx === null || ctx === void 0 ? void 0 : (_ctx$data2 = ctx.data) === null || _ctx$data2 === void 0 ? void 0 : (_ctx$data2$event = _ctx$data2.event) === null || _ctx$data2$event === void 0 ? void 0 : _ctx$data2$event.startsWith(key);
                    });
                    eventType = eventTypes[eventTypeKey];
                  }
                  if (eventType) {
                    var data = ctx === null || ctx === void 0 ? void 0 : ctx.data;
                    eventType.emit(context, data);
                    if (eventType.action) {
                      eventType.action(context, data);
                    }
                  }
                } catch (e) {
                  console.log(e);
                }
              });
              _this.instance.on('error', function (ctx) {
                // now client disconnected from Centrifugo
                console.log(ctx);
              });
              _context2.next = 15;
              return _this.instance.connect();
            case 15:
              _context2.next = 20;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 17]]);
      }))();
    },
    disconnect: function disconnect() {
      if (this.instance) {
        this.instance.disconnect();
        this.channel = null;
      }
    }
  };
  inject('centrifuge', plugin);
});